import { render } from "./LoginEmail.vue?vue&type=template&id=1fc45f74&scoped=true"
import script from "./LoginEmail.vue?vue&type=script&lang=js"
export * from "./LoginEmail.vue?vue&type=script&lang=js"

import "./LoginEmail.vue?vue&type=style&index=0&id=1fc45f74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc45f74"]])

export default __exports__